import styled from "../../../config/emotion";
import { StyledCompProps } from "../../../globalTypes/theme";

type InputProps = StyledCompProps & {
  vertical?: boolean;
  password?: boolean;
};

export const InputContainer = styled.div<InputProps>`
  display: flex;
  margin: 5px 0;
  ${({ vertical }) => {
    if (vertical) {
      return `
        flex-direction: column;
        margin-bottom: 0;
        align-items: flex-start;
      `;
    }
    return "flex-direction: row; align-items: center";
  }}
`;

export const LabelContainer = styled.div<InputProps>`
  color: ${({ theme }) => theme.colors.secondaryColor};
  ${({ vertical, password }) => {
    if (vertical) {
      return `
        label {
          margin-bottom: 5px;
          margin-left: ${password && "12px;"}
        };
      `;
    }
    return `
      width: 40%;
      text-align: left;
      `;
  }};
`;

export const ErrorLabel = styled.label<InputProps & StyledCompProps>`
  color: ${({ theme }) => theme.colors.delete};
  font-size: 10px;
  margin-top: 3px;
  ${({ password }) => password && "margin-left: 12px;"}
`;

export const InputWrapper = styled.div<InputProps>`
  ${({ vertical }) => {
    if (!vertical) {
      return `
        width: 60%;
        text-align: left;
      `;
    }
    return `text-align: center`;
  }};
`;

export const Label = styled.label<StyledCompProps>`
  color: ${({ theme }) => theme.colors.secondaryColor};
  font-size: 16px;
  font-weight: bold;
`;

export const Input = styled.input`
  padding: 0.4em 1em;
  border-radius: 25px;
  border: 1px solid #ced4da;
  background: white;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  margin: 0;
  width: 100%;
`;
